import get from 'lodash/get'
import * as Sentry from '@sentry/browser'

import { getListing, getSimilarListings } from '../api/nestready/requests'
import {
  SET_SIMILAR_LISTINGS,
  FETCH_LISTING_REQUEST,
  FETCH_LISTING_SUCCESS,
  FETCH_LISTING_FAILURE,
} from './actionTypes'

export const setSimilarListings = listings => ({
  type: SET_SIMILAR_LISTINGS,
  listings,
})

export const fetchListing = (customerId, listingId) => dispatch => {
  dispatch({ type: FETCH_LISTING_REQUEST })

  getListing(customerId, listingId)
    .then(resp => {
      const listing = get(resp, 'data.data', [])
      dispatch({ type: FETCH_LISTING_SUCCESS, listing })
    })
    .catch(error => {
      dispatch({ type: FETCH_LISTING_FAILURE })

      Sentry.captureException(error)
    })
}

export const fetchSimilarListings =
  (listingId, transform = true) =>
  dispatch => {
    getSimilarListings(listingId)
      .then(resp => {
        const listings = get(resp, 'data.listings', [])

        if (!transform) {
          dispatch(setSimilarListings(listings))
        } else {
          const transformedListings = listings.map(listing => {
            const {
              id,
              address,
              bedroomsCount,
              bathroomsCount,
              priceFormatted,
              priceCents,
              mlsNumber,
              sqftTotal,
              status,
              thumbnailImageFileNames,
            } = listing

            return {
              id,
              address,
              bedrooms: bedroomsCount,
              bathrooms: bathroomsCount,
              priceFormatted, // ListCard expects priceFormatted, not formattedPrice
              formattedPrice: priceFormatted, // ListingCarousel used for YLOPO and ListHub listings expects formattedPrice
              price: priceCents / 100,
              livingAreaSqFt: sqftTotal,
              mainPhoto: thumbnailImageFileNames[0],
              mlsNumber,
              status,
              thumbnailImageFileNames,
            }
          })
          dispatch(setSimilarListings(transformedListings))
        }
      })
      .catch(error => {
        Sentry.captureException(error)
      })
  }
